// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"76656050","81":"a3e072f7","787":"204a606d"}[chunkId] + ".chunk.js";
};